<div class="d-flex flex-column align-items-stretch wrapper mt-2 mb-1">
    <div class="d-flex align-items-center mb-3" *ngIf="icon || label">
        <i class="icon {{icon}} me-2" *ngIf="icon"></i>
        <div *ngIf="label" class="font-large color-greyish">{{ label | translate}}</div>
    </div>
    <div class="w-100" #textAreaRef>
        <textarea rows="3" *ngIf="form && froala && froalaOptions" [formControl]="form" [froalaEditor]="froalaOptions"
            class="w-100"></textarea>
        <textarea rows="3" *ngIf="!form && froala && froalaOptions" [(froalaModel)]="model" [froalaEditor]="froalaOptions"
            class="w-100"></textarea>
        <textarea rows="3" *ngIf="!froala" [formControl]="form" class="w-100"></textarea>
    </div>
    <mapfre-auditlib-form-errors *ngIf="form" [form]="form" [targetRef]="textAreaRef" [skipHighlighter]="skipHighlighter"></mapfre-auditlib-form-errors>
</div>